import React from 'react';
import { Box, Typography, Divider, Paper } from '@mui/material';

/**
 * Composant d'en-tête de page réutilisable
 * @param {Object} props - Propriétés du composant
 * @param {string} props.title - Titre principal de la page
 * @param {string} [props.subtitle] - Sous-titre optionnel
 * @param {React.ReactNode} [props.icon] - Icône optionnelle à afficher
 * @param {Object} [props.action] - Élément d'action optionnel (bouton, etc.)
 */
const PageHeader = ({ title, subtitle, icon, action }) => {
    return (
        <Paper
            elevation={0}
            sx={{
                p: 3,
                mb: 3,
                borderRadius: 2,
                background: 'transparent',
                border: 'none'
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: subtitle ? 1 : 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {icon && (
                        <Box
                            sx={{
                                mr: 2,
                                display: 'flex',
                                alignItems: 'center',
                                color: 'primary.main',
                                fontSize: '2rem'
                            }}
                        >
                            {icon}
                        </Box>
                    )}
                    <Typography variant="h4" component="h1" fontWeight="bold">
                        {title}
                    </Typography>
                </Box>

                {action && (
                    <Box>
                        {action}
                    </Box>
                )}
            </Box>

            {subtitle && (
                <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    sx={{ ml: icon ? 6 : 0 }}
                >
                    {subtitle}
                </Typography>
            )}

            <Divider sx={{ mt: 2 }} />
        </Paper>
    );
};

export default PageHeader;